<template>
    <div class="relative">
        <Listbox v-bind="$attrs">
            <ListboxButton class="relative w-full border-2 text-lg text-white text-left py-2 px-4 border-gradient-to-br from-purple to-blue bg-dark-blue focus:outline-none focus:from-yellow focus:via-white focus:to-yellow disabled:opacity-50">
                <div class="block"><slot name="label">Select...</slot></div>
                <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4">
                    <DownChevronIcon />
                </span>
            </ListboxButton>
            <ListboxOptions class="absolute max-h-60 overflow-auto bg-dark-blue z-50 w-full focus:outline-none">
                <slot></slot>
            </ListboxOptions>
        </Listbox>
    </div>
</template>

<script>
export default {
  inheritAttrs: false
}
</script>

<script setup>
import { computed } from 'vue';
import {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
} from '@headlessui/vue'

import DownChevronIcon from '../icons/DownChevronIcon.vue';
</script>